import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import { usePricingModulesState } from '../../context/contexts/PricingModuleContext';
import ItdrCloud from '../../components/Risk/Cloud/ItdrCloud';
import { CloudITDRBlockedPage } from '../../modules/itdr/ITDRBlockPage/CloudITDRBlockedPage';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const ItdrCloudRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();

    const displayBlockPage = isPageBlocked(LAYOUT_TABS.ITDR_CLOUD.ID);
    const hasOnPremPermissions = useHasPermissions({ permission: Pages.RISK, role: Roles.VIEWER });

    return (
        <LogicalRoute
            {...props}
            component={ItdrCloud}
            disabled={!hasOnPremPermissions}
            blockPageComponent={CloudITDRBlockedPage}
            displayBlockPage={displayBlockPage}
        />
    );
};
